@if (show) {
  <ngb-toast
    #myToast
    class="position-fixed bottom-0 end-0 mb-4 me-4"
    style="z-index: 2000"
    [autohide]="true"
    [delay]="5000"
    (hidden)="app.releaseNotesBanner.updateProfile(); show = false"
    >
    <div class="toast-header">
      <strong class="me-auto"
        >{{ app.text.releaseNotesModal.bannerTitle }}{{ lastVersion }}</strong
        >
      </div>
      <div class="toast-body">
        <div class="d-flex align-items-center">
          <div class="me-auto">
            <i class="fa-solid fa-bell text-warning me-2"></i>
            <strong>{{ app.text.releaseNotesModal.bannerMessage }}</strong>
          </div>
          <button
            type="button"
            class="btn btn-sm view-btn ms-3"
            (click)="app.releaseNotesBanner.openReleaseNotesModal()"
            >
            {{ app.text.releaseNotesModal.view }}
          </button>
        </div>
      </div>
    </ngb-toast>
  }
